import StepFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/NewFlowEp';
import stepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepFlow
    }
  ],
  options: ['submit'],
  submitAction: 'sendNewFileFlow',
  loadAllData: false,
  documentMapper(input) {
    const data = {
      adjuntos: [],
      aprobacionId: input.flowId,
      ejecucion: {
        privado: input.private ? 'Y' : 'N',
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        tipoReferencia: 'ARCHIVO',
        aprobacionesReferenciaId: input.flowId,
        tipoObjetoCategoria: 'EDP',
        foliacion: true,
        precioFlujo: input.amount,
        reversible: true,
        plantilla: {
          aprobaciones: {
            nombre: input.name,
            descripcion: input.description,
            estampar: input.pdfStamp,
            numeroReferencia: 0,
            reversible: true,
            tipoObjeto: input.objectType
          },
          aprobacionesPlantillaPaso: (input.steps || []).map((step) => {
            let mappedStep = {
              desdePrecio: 0,
              gatillacionesAInsertar: [],
              cantidadMinAprobacion: 1,
              demoraMaxHoras: 0,
              redirigirFlujo: true,
              subrogadoId: '',
              subrogado: '',
              aprobacionesTipoPasoId: step.stepType,
              aprobacionesTipoRolId: step.rolType,
              grupoUsuarios: step.groupUsers || [],
              numeroPaso: step.stepNumber,
              responsable: step.responsibleName,
              responsableCorreo: step.responsibleEmail,
              tipoValorResponsableId: step.responsibleId
            };
            if (step.stepType === stepTypes.EXTERNAL) {
              mappedStep = {
                ...mappedStep,
                responsableIut: step.data.responsable.rut,
                responsableTerceroIut: step.data.extra.empresa.iut,
                responsableTerceroNombre: step.data.extra.empresa.razon,
                tipoFirma: step.tipoFirma

              };
            }
            return mappedStep;
          })
        }
      },
      documentos: [
        {
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          adjuntoUrl: input.mainFile.path,
          fecha: input.mainFile.date,
          objetoId: input.mainFile.id,
          objetoNombre: input.mainFile.name,
          tipoObjetoId: 'ARCHIVO',
          tipoObjetoTexto: 'ARCHIVO - '
        }
      ]
    };
    if (input.oldFlow && input.objectType) {
      data.ejecucion.tipoReferencia = input.objectType;
      data.ejecucion.numeroReferencia = input.number;
    }
    if (input.attachments.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.attachments || []).map((file) => ({
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          adjuntoId: file.id,
          adjuntoEstado: 2,
          fecha: file.date,
          adjuntoUrl: file.path
        }))
      ];
    }
    data.meta = { oficinaAcciones: ['fechar'] };

    return data;
  }
});
